import axios from 'axios';
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

const request = {
    registerExam: (gradedActivityId, studentCourseImplementationId) =>{
        let obj={
            gradedActivityId,
            studentCourseImplementationId
        }
        axios.post('/student-exams/registration/', {...obj})},
    cancelExam: (studentGradedActivityId) =>
        axios.put(`/student-exams/cancellation/${studentGradedActivityId}`),
    fetchExamsToRegister: () =>
        axios.get('/student-exams/registration/unregistered/'),
    fetchExamsToCancel: () =>
        axios.get('/student-exams/registration/registered/false'),
    fetchAllPastRegisteredExams: () =>
        axios.get('/student-exams/registration/registered/true'),
    fetchGradedActivityTypes: () =>
        axios.get('/graded-activity-types')
};

export default request;



// WEBPACK FOOTER //
// ./src/views/StudentRegisterExams/request.js